import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React from "react";

const Popup = ({ open, title, body, actions }) => {
  return (
    <Dialog open={open} id="popupContainer" scroll="paper">
      {title && <DialogTitle className="popupTitle">{title}</DialogTitle>}
      {body && <DialogContent id="popupBody">{body}</DialogContent>}
      {actions && <DialogActions id="popupActions">{actions}</DialogActions>}
    </Dialog>
  );
};

export default Popup;
